import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { minTouchTargetPx } from '../../tokens/spacing.js';
export const Input = React.forwardRef(function Input({ className, style, ...rest }, ref) {
    return (_jsx("input", { ref: ref, className: className, "data-input": true, style: {
            display: 'block',
            width: '100%',
            minHeight: `${minTouchTargetPx}px`,
            padding: `var(--space-2) var(--space-3)`,
            borderRadius: 'var(--radius-input)',
            border: '1px solid var(--text-dim)',
            background: 'var(--surface)',
            color: 'var(--text)',
            fontFamily: 'var(--font-ui)',
            fontSize: 'max(16px, var(--font-size-2xs))',
            outlineColor: 'var(--focus-ring)',
            ...style,
        }, ...rest }));
});
//# sourceMappingURL=Input.js.map